const rail = {
  rails: "Đường ray", // translated 
  senior: "Người lớn tuổi", // translated 
  seniors: "Người cao tuổi", // translated 
  youths: "Thanh niên", // translated 
  yearOld: "tuổi", // translated 
  yearsOld: "tuổi", // translated 
};


export default rail;
